import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { keysToSnakeCase } from "lib/helpers";
import SessionClient from "util/SessionClient";
import messages from "../messages";

function* createNewUser(action) {
  const { hisLicenseNumber, hisLicenseExpires, ...userPayload } = action.payload;
  const { success, data, error } = yield* makeRequest.post("/users", keysToSnakeCase(userPayload));

  if (success && data) {
    const session = new SessionClient();
    session.setSession(data);
    session.user.initStore(data);

    if (hisLicenseNumber) {
      const profileRes = yield* makeRequest.get("/profile", {});
      if (profileRes.success && profileRes.data) {
        const licenses = profileRes.data.body?.licenses || [];
        const hisLicense = licenses.find((l) => l.name === "CSLB HIS#");
        if (hisLicense) {
          yield put(
            actions.createLicense({
              id: hisLicense.id,
              identifier: hisLicenseNumber,
              expires: hisLicenseExpires,
            }),
          );
        }
      }
    }

    yield put(
      actions.newSuccessEvent({
        message: messages.CREATE_NEW_USER_SUCCESS,
        payload: data,
      }),
    );
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_CREATING_NEW_USER,
    });
  }

  return null;
}

export default createNewUser;
